const topics = [
  { label: '#某女星恋情曝光', hot: true },
  { label: '#综艺节目造假', hot: true },
  { label: '#顶流塌房后续', hot: true },
  { label: '#网红偷税漏税', hot: false },
  { label: '#剧组霸凌事件', hot: true },
  { label: '#直播带货翻车', hot: false },
  { label: '#选秀节目内定', hot: false },
  { label: '#艺人合约纠纷', hot: true },
  { label: '#饭圈互撕大战', hot: false },
  { label: '#音乐节假唱', hot: true },
  { label: '#跨年晚会幕后', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="scroll-mt-20 py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">热门话题</h2>
          <p className="mt-2 text-sm text-foreground-500">当前最火的吃瓜话题都在这里</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <span
              key={topic.label}
              className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium cursor-pointer transition-colors whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200 border border-primary-200/60'
                  : 'bg-secondary-100 text-secondary-700 hover:bg-secondary-200 border border-secondary-200/60'
              }`}
            >
              {topic.hot && <i className="ri-fire-line text-xs"></i>}
              {topic.label}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}